import { AspectRatio } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function AspectRatioDemo() {
  return (
    <Section
      id="aspect-ratio"
      title="AspectRatio"
      description="Lock a child to a fixed width:height ratio. Useful for video tiles, thumbnails, embeds."
    >
      <VariantBlock label="16 / 9">
        <div className="w-80">
          <AspectRatio
            ratio={16 / 9}
            className="overflow-hidden rounded-md bg-muted"
          >
            <div className="flex h-full w-full items-center justify-center text-sm text-muted-foreground">
              16 / 9 surface
            </div>
          </AspectRatio>
        </div>
      </VariantBlock>

      <VariantBlock label="1 / 1 (square)">
        <div className="w-48">
          <AspectRatio
            ratio={1}
            className="overflow-hidden rounded-md bg-muted"
          >
            <div className="flex h-full w-full items-center justify-center text-sm text-muted-foreground">
              1 / 1
            </div>
          </AspectRatio>
        </div>
      </VariantBlock>

      <VariantBlock label="4 / 5 (portrait)">
        <div className="w-48">
          <AspectRatio
            ratio={4 / 5}
            className="overflow-hidden rounded-md bg-muted"
          >
            <div className="flex h-full w-full items-center justify-center text-sm text-muted-foreground">
              4 / 5
            </div>
          </AspectRatio>
        </div>
      </VariantBlock>
    </Section>
  );
}
